export const AuthRoutes = {
    Base: '/auth',
    FirstLogin: 'first-login',
    ForgotPassword: 'forgot-password',
    ResetForgotPassword: 'reset-forgot-password',
    ExpiredLink: '/expired-link',
};
